import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mcompany-introduce',
  templateUrl: './company-introduce.component.html',
  styleUrls: ['./company-introduce.component.scss']
})
export class McompanyIntroduceComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
